import Api from '../api';
import Config from 'config';
import { AuthStrategy } from '@lwtears/lwt-common-frontend/lib/@common/util/api-util';

const routePrefix = '/books';

const getBooks = () => {
  const params = { include: ['teachersGuides', 'workbooks', 'products'] };
  return Api.get(routePrefix, { params });
};

const getAppBooks = () => {
  return Api.get(routePrefix, AuthStrategy.APP_SERVICE_CREDENTIALS, {
    params: {
      include: ['teachersGuides', 'workbooks', 'products'],
      // NOTE: #notgood - this includes 'edition' header so that the browser does not cache
      // 'getBooks' (which fails on backend before cache headers are set)
      edition: [Config.defaultEdition]
    }
  });
};

const getBookContent = (bookId: number, params: any = {}) => {
  return Api.get(`${routePrefix}/${bookId}/content`, { params });
};

const getBookPages = (bookId: number, params: any = {}) => {
  return Api.get(`${routePrefix}/${bookId}/pages`, { params });
};

const getBookFilters = (bookId: number, params: any = {}) => {
  return Api.get(`${routePrefix}/${bookId}/filters`, { params });
};

export { getBooks, getBookContent, getBookPages, getBookFilters, getAppBooks };
